<template lang="html">
  <div class="dungeon-map">
    <SelectSlider
      title="Ausgewählter Bereich:"
      :options="areas"
      :defaultOption="currentAreaIndex"
      @changeOption="changeArea"
    />

    <panZoom
      :options="options"
      selector=".dungeon-map__zoom"
      @init="onInit"
      @transform="transformEvent"
      @panend="endMoving"
      @zoomend="endMoving"
    >
      <div class="dungeon-map__zoom">
        <svg
          width="290"
          height="258"
          viewBox="0 0 290 258"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          id="DungeonMap"
        >
          <g clip-path="url(#clip0_2_2)">
            <path
              d="M48.5 257.8C46.3 257.8 44.3 257 42.8 255.5L5.80001 218.5C2.70001 215.2 2.70001 210 5.80001 206.9L8.10001 204.6C8.50001 204.2 8.70001 204 9.10001 203.8L9.60001 203.6V171.2H0.700012V95.2H9.50001V64.6L9.30001 64.4C8.90001 64 8.50001 63.7 8.00001 63.4L5.80001 61.3C2.70001 58 2.70001 52.8 5.80001 49.7L42.8 12.6C44.4 11.1 46.5 10.3 48.7 10.3C50.9 10.3 52.9 11.1 54.4 12.6L56.7 14.9C57.3 15.5 57.7 16 57.9 16.5L58.1 17H192L192.2 16.4C192.7 15.4 193.2 14.6 194 13.7L196.3 11.4C197.9 9.9 200 9.1 202.2 9.1C204.4 9.1 206.4 9.9 207.9 11.4L245.1 48.4C248.2 51.7 248.2 56.9 245.1 60L242.8 62.3C241.2 63.9 239.2 64.7 237 64.7C236.3 64.7 235.7 64.6 235 64.5L233.8 64.1V87L235 86.8C237.5 86.4 240 86.2 242.4 86.2C268.4 86.2 289.5 107.3 289.5 133.2C289.5 159.1 268.4 180.2 242.4 180.2C240.8 180.2 239.3 180.1 237.7 180H237.4C237 180 236.6 179.9 236.1 179.9C235.7 179.9 235.3 179.9 234.8 179.8H233.7V201.5L235 201.1C235.6 200.9 236.3 200.9 237 200.9C239.2 200.9 241.2 201.8 242.7 203.3L245 205.6C248.1 208.9 248.1 214.1 245 217.2L208 254.2C206.4 255.7 204.3 256.5 202.1 256.5C199.9 256.5 197.9 255.7 196.4 254.2L194.1 251.9C193.5 251.3 193.1 250.8 192.9 250.3L192.7 249.8H58.7L58.5 250.4C58 251.4 57.5 252.2 56.7 253.1L54.4 255.4C52.8 257 50.7 257.8 48.5 257.8Z"
              fill="#D4D4D4"
            />
            <path
              d="M202.2 9.3C204.3 9.3 206.2 10.1 207.6 11.5L244.8 48.5C247.7 51.6 247.7 56.5 244.8 59.4L242.5 61.7C241 63.2 239.1 64 237.1 64C236.5 64 235.9 63.9 235.3 63.8L234.7 63.6L233.4 63.2V64.6V65.2V85.9V86.5V87.7L234.6 87.5L235.2 87.4C237.6 87 240.1 86.8 242.6 86.8C268.3 86.8 289.2 107.7 289.2 133.3C289.2 158.9 268.3 179.8 242.6 179.8C241 179.8 239.5 179.7 237.9 179.6H237.7C237.3 179.5 236.8 179.5 236.4 179.5C236 179.5 235.6 179.5 235.1 179.4H235H234.9H234.4H233.4V180.4V180.9V200.3V200.9V202.3L234.7 201.9L235.3 201.7C235.9 201.6 236.6 201.5 237.2 201.5C239.3 201.5 241.1 202.3 242.6 203.8L244.9 206.1C247.8 209.2 247.8 214.1 244.9 217L207.9 254C206.4 255.4 204.4 256.2 202.3 256.2C200.2 256.2 198.3 255.4 196.9 254L194.6 251.7C194.1 251.2 193.7 250.7 193.5 250.3L193.4 250.1L193.1 249.5H192.5H192.2H59.4H59.1H58.4L58.2 250.2L58.1 250.4C57.7 251.4 57.1 252.2 56.4 253L54.1 255.3C52.6 256.7 50.6 257.5 48.5 257.5C46.4 257.5 44.5 256.7 43.1 255.3L6.1 218.3C3.2 215.2 3.2 210.3 6.1 207.4L8.4 205.1C8.8 204.7 9 204.5 9.2 204.4L9.4 204.3L10 204V203.4V203.1V172.4V171.8V170.8H9H8.4H1V95.8H8.3H8.8H9.8V94.8V94.3V65.1V64.9V64.5L9.5 64.2L9.4 64.1C9 63.7 8.5 63.3 8.1 63.1L6 61C3.1 57.9 3.1 53 6 50.1L43 13C44.5 11.6 46.5 10.8 48.6 10.8C50.7 10.8 52.6 11.6 54 13L56.3 15.3C56.8 15.8 57.2 16.3 57.4 16.7L57.5 16.9L57.8 17.5H58.4H58.7H191.3H191.6H192.3L192.5 16.8L192.6 16.6C193 15.6 193.6 14.8 194.3 14L196.6 11.7C198.1 10.1 200.1 9.3 202.2 9.3ZM202.2 8.3C200 8.3 197.7 9.1 196 10.8L193.7 13.1C192.9 14 192.3 14.9 191.8 16L191.7 16.3H191.4H58.8H58.5L58.4 16.1C58.1 15.5 57.6 14.9 57.1 14.4L54.8 12.1C53.1 10.4 50.9 9.6 48.7 9.6C46.5 9.6 44.2 10.4 42.5 12.1L5.5 49.2C2.2 52.5 2.2 58 5.5 61.5L7.7 63.7C8.1 63.9 8.5 64.2 8.9 64.6L9 64.7V64.9V94.1V94.6H8.5H0V171.6H8.3H9V172.2V202.9V203.2L8.8 203.3C8.4 203.5 8.1 203.8 7.7 204.2L5.4 206.5C2.1 209.8 2.1 215.3 5.4 218.8L42.4 255.8C44.1 257.5 46.3 258.3 48.5 258.3C50.7 258.3 53 257.5 54.7 255.8L57 253.5C57.8 252.6 58.4 251.7 58.9 250.6L59 250.3H59.3H192.1H192.4L192.5 250.5C192.8 251.1 193.3 251.7 193.8 252.2L196.1 254.5C197.8 256.2 200 257 202.2 257C204.4 257 206.7 256.2 208.4 254.5L245.4 217.5C248.7 214.2 248.7 208.7 245.4 205.2L243.1 202.9C241.4 201.2 239.3 200.3 237 200.3C236.3 200.3 235.6 200.4 234.8 200.6L234.2 200.8V200.2V180.8V180.3H234.7C235.6 180.4 236.5 180.4 237.3 180.5C239 180.6 240.6 180.7 242.3 180.7C268.6 180.7 289.9 159.4 289.9 133.2C289.9 106.9 268.6 85.7 242.3 85.7C239.8 85.7 237.3 85.9 234.8 86.3L234.2 86.4V85.8V65.1V64.5L234.8 64.7C235.5 64.9 236.2 65 236.9 65C239.1 65 241.3 64.2 243 62.4L245.3 60.1C248.6 56.8 248.6 51.3 245.3 47.8L208.1 10.8C206.6 9.1 204.4 8.3 202.2 8.3Z"
              fill="#C99D66"
            />
            <path
              d="M257 100H248V98V97H247H235H234V98V100H224H223V101V113H211V110V109H210H202H201V110V113H173V104.3L147.7 79H139V44H143H144V43V36V35H143H141V29H140H123V1V0H122H113H112V1V29H96H95V30V35H93H92V36V43V44H93H97V79H89.7H88.3L87.3 80L63 104.3V114H26V110V109H25H18H17V110V114H10H9V115V155V156H10H17V160V161H18H25H26V160V156H63V164.7L88.3 190H97V224H93H92V225V232V233H93H97V240V241H98H138H139V240V233H143H144V232V225V224H143H139V190H147.7L173 164.7V156H201V160V161H202H210H211V160V156H223V168V169H224H234V171V172H235H247H248V171V169H257H258V168V137V132V101V100H257ZM257 132V137V168H248H247V169V171H235V169V168H234H224V156V155H223H211H210V156V160H202V156V155H172V156V164.3L147.3 189H139H138V190V224V225H139H143V232H139H138V233V240H98V233V232H97H93V225H97H98V224V190V189H97H88.7L64 164.3V156V155H63H26H25V156V160H18V156V155H17H10V115H17H18V114V110H25V114V115H26H63H64V114V104.7L88.7 80H97H98V79V44V43H97H93V36H95H96V35V30H112H113V29V1H122V29V30H123H140V35V36H141H143V43H139H138V44V79V80H139H147.3L172 104.7V113V114H201H202V113V110H210V113V114H211H223H224V113V101H234H235V100V98H247V100V101H248H257V132Z"
              fill="#fff"
            />
            <path
              d="M98 155H82V164.7L88.4 171.1H98.1L98 155ZM88.7 170.1L82.9 164.3V156H97V170.1H88.7Z"
              fill="#C99D66"
            />
            <path
              d="M138 155V171H147.7L154.1 164.6V155H138ZM139 170.1V156H153.1V164.3L147.3 170.1H139V170.1Z"
              fill="#C99D66"
            />
            <path
              d="M138 114H154V104.3L147.6 97.9H138V114ZM147.3 98.9L153.1 104.7V113H139V98.9H147.3V98.9Z"
              fill="#C99D66"
            />
            <path
              d="M98 114V98H88.3L81.9 104.4V114.1L98 114ZM97 98.9V113H82.9V104.7L88.7 98.9H97V98.9Z"
              fill="#C99D66"
            />
            <path
              d="M248 101H247V100V98H235V100V101H234H224V113V114H223H211H210V113V110H202V113V114H201H172V113V104.7L147.3 80H139H138V79V44V43H139H143V36H141H140V35V30H123H122V29V1H113V29V30H112H96V35V36H95H93V43H97H98V44V79V80H97H88.7L64 104.7V114V115H63H26H25V114V110H18V114V115H17H10V155H17H18V156V160H25V156V155H26H63H64V156V164.3L88.7 189H97H98V190V224V225H97H93V232H97H98V233V240H138V233V232H139H143V225H139H138V224V190V189H139H147.3L172 164.3V156V155H202V156V160H210V156V155H211H223H224V156V168H234H235V169V171H247V169V168H248H257V137V132V101H248ZM98 171H88.3L81.9 164.6V155H97.9V171H98ZM98 114H82V104.3L88.4 97.9H98.1V114H98ZM154.1 164.7L147.7 171.1H138V155.1H154V164.7H154.1ZM154.1 114H138V98H147.7L154.1 104.4V114Z"
              fill="#fff"
            />
            <template v-for="wall in walls" :key="wall.slug">
              <path
                class="dungeon-map__wall"
                :id="wall.slug"
                :class="{
                  'dungeon-map__wall--selected': selectedWallSlug === wall.slug,
                }"
                :d="fragments[wall.slug]"
                @touchstart="touchEventSelectOnMap(wall)"
                @click="clickEventSelectOnMap(wall)"
              />
            </template>
          </g>
          <defs>
            <clipPath id="clip0_2_2">
              <rect width="290" height="258" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>
    </panZoom>

    <div class="dungeon-map__info">
      <div class="dungeon-map__info-area">
        Bereich:
        <b v-if="selectedAreaOption.label">{{ selectedAreaOption.label }}</b>
      </div>
      <div class="dungeon-map__info-wall">
        Gemäuer:
        <b v-if="selectedWallOption.name">{{ selectedWallOption.name }}</b>
      </div>
    </div>
    <SelectSlider
      title="Ausgewähltes Gemäuer:"
      label="name"
      placeholder="Gemäuer auswählen"
      :options="walls"
      :defaultOption="currentWallIndex"
      :counter="true"
      :infoButton="
        !!selectedWallOption.image_for_modal ||
        selectedWallOption.description !== ''
      "
      @changeOption="changeWall"
      @openInfo="openInfo"
    />
  </div>

  <ModalWindow :show="showModal" @closeModal="closeModal">
    <div class="wall-info">
      <div class="wall-info__image" v-if="selectedWallOption.image">
        <img
          :src="selectedWallOption.image.sizes.medium_large"
          alt="selectedWallOption.image_for_modal.alt"
        />
      </div>
      <div class="wall-info__heading">
        {{ selectedWallOption.name }}
      </div>
      <div
        class="wall-info__description"
        v-if="selectedWallOption.description"
        v-html="selectedWallOption.description"
      ></div>
      <div class="wall-info__button">
        <Button styleButton="border" @click="closeModal">
          <!--          <span> Zurück zur Steinauswahl </span>-->
          <span> Zurück </span>
        </Button>
      </div>
    </div>
  </ModalWindow>
</template>

<script>
import SelectSlider from '@/components/SelectSlider/SelectSlider';
import ModalWindow from '@/components/ModalWindow/ModalWindow';
import Button from '@/components/Button/Button';
import dungeonMap from '@/mixins/dungeon-map-component';

export default {
  name: 'DungeonMap',
  components: { Button, ModalWindow, SelectSlider },
  mixins: [dungeonMap],
};
</script>

<style lang="scss" scoped>
@import 'styles';

.wall-info {
  &__container {
    border-radius: 6px;
  }

  &__image {
    height: 0;
    padding-bottom: calc(160 / 335 * 100%);
    position: relative;
    margin-bottom: 20px;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      position: absolute;
      left: 0;
      top: 0;
    }
  }

  &__heading {
    font-size: 22px;
    color: #c99d66;
    text-align: center;
  }

  &__button {
    width: 197px;
    margin: 26px auto 0;
    &:deep {
      .button {
        border-radius: 0;
      }
    }
  }
}
</style>
